import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';

interface ExistingScheduledConflictModalProps {
  open: boolean;
  scheduledLabel: string;
  previewText: string;
  onEditExisting: () => void;
  onReplaceWithNew: () => void;
  onCancel: () => void;
}

const ExistingScheduledConflictModal: React.FC<ExistingScheduledConflictModalProps> = ({
  open,
  scheduledLabel,
  previewText,
  onEditExisting,
  onReplaceWithNew,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
          <Typography variant="overline" color="text.secondary">
            Smart Send Conflict
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Stack spacing={1.5}>
          <Typography variant="body1" color="text.primary">
            There is already a scheduled draft for this conversation.
          </Typography>
          <Box
            sx={{
              border: (t) => `1px solid ${t.palette.divider}`,
              borderRadius: 1,
              p: 1.25,
              bgcolor: (t) => t.palette.action.hover,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', mb: 0.5 }}
            >
              Scheduled for
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.75 }}>
              {scheduledLabel}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', mb: 0.5 }}
            >
              Preview
            </Typography>
            <Typography variant="body2" color="text.primary" sx={{ whiteSpace: 'pre-line' }}>
              {previewText || '(no content)'}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 0 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onReplaceWithNew} color="warning" variant="outlined">
          Replace with new
        </Button>
        <Button onClick={onEditExisting} variant="contained">
          Edit existing
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExistingScheduledConflictModal;
